export const useNumbers = () => {
  const toReadableNumber = (value) => {
    if (!value) return 0;
    if (isNaN(value)) return value;
    return Number(Number(value).toFixed(2)).toLocaleString();
  };

  return { toReadableNumber };
};
